export default class Transaction {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    find(id) {
        return this.rest.one('transactional', id).get();
    };

    findAllByName(page, view, search) {
        return this.rest.one('transactional').get({ 
            page: page || 1,
            view: view || 'cards',
            query: search || null
        });
    };

    createAndSendTextMessage(textMessage) {
        return this.rest.all('transactional/sendTextMessage').post(textMessage);
    };
};